/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar, NavbarBrand, NavItem, NavLink } from 'reactstrap';
import { Login } from '../Login';
import { sysAdminCachePath } from '../SysAdminApp/CacheStatisticsComponent';
import { ErrorMessage } from '../System/ErrorMessage';

export const MenuSysAdmin: React.FC<{}> = () => {
    return (
        <div>
            <Navbar color="light">
                <NavbarBrand tag={Link} to={'/'}>
                    Funtip-SysAdmin
                </NavbarBrand>
                <Nav>
                    <NavItem>
                        <NavLink tag={Link} to={'/sys/jobs'}>
                            Jobs
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={'/sys/sql'}>
                            SQL Statistics
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={sysAdminCachePath('betting')}>
                            Caches
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={'/sys/usage'}>
                            Rest-Clients
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={'/sys/ucl'}>
                            UseCaseLogs
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={'/sys/event-handler'}>
                            Event-Handler
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={'/sys/properties'}>
                            System-Properties
                        </NavLink>
                    </NavItem>
                    <Login />
                    <ErrorMessage />
                </Nav>
            </Navbar>
        </div>
    );
};
